import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksFinanceAttributions(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].getDoneWorksFinanceAttributions,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksFinanceAttributionPreview(companyId, doneWorkId, financeAttributionId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].getDoneWorksFinanceAttributionPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				financeAttributionId,
			},
		},
	)
}
function getDoneWorksFinanceAttributionPopup(companyId, doneWorkId, financeAttributionId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].getDoneWorksFinanceAttributionPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				financeAttributionId,
			},
		},
	)
}

function createDoneWorksFinanceAttribution(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].createDoneWorksFinanceAttribution, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksFinanceAttribution(companyId, doneWorkId, financeAttributionId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].getDoneWorksFinanceAttribution, {
		urlParams: {
			companyId,
			doneWorkId,
			financeAttributionId,
		},
	})
}

function patchDoneWorksFinanceAttribution(companyId, doneWorkId, financeAttributionId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].patchDoneWorksFinanceAttribution, {
		urlParams: {
			companyId,
			doneWorkId,
			financeAttributionId,
		},
		...data,
	})
}

function putDoneWorksFinanceAttribution(companyId, doneWorkId, financeAttributionId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].putDoneWorksFinanceAttribution, {
		urlParams: {
			companyId,
			doneWorkId,
			financeAttributionId,
		},
		...data,
	})
}

function deleteDoneWorksFinanceAttribution(companyId, doneWorkId, financeAttributionId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].deleteDoneWorksFinanceAttribution, {
		urlParams: {
			companyId,
			doneWorkId,
			financeAttributionId,
		},
	})
}

export default {
	getDoneWorksFinanceAttributions,
	getDoneWorksFinanceAttributionPopup,
	getDoneWorksFinanceAttributionPreview,
	getDoneWorksFinanceAttribution,
	patchDoneWorksFinanceAttribution,
	putDoneWorksFinanceAttribution,
	createDoneWorksFinanceAttribution,
	deleteDoneWorksFinanceAttribution,
}
